export default __webpack_public_path__ + "static/media/izugi.6959a5e9.png";